import React from 'react';
import LandingPage from './components/LandingPage';
import CustomCursor from './components/CustomCursor';
import AboutMe from "./components/About-me";

function App() {
  return (
      <div className="App">
              <LandingPage/>
              <CustomCursor/>
              <AboutMe/>
          {/*<Router>*/}
          {/*    <Routes>*/}
          {/*        <Route path="/about-me" element={<AboutMe />} />*/}
          {/*    </Routes>*/}
          {/*</Router>*/}
          </div>
          );
}
export default App;

